import { useTranslation as i18nextUseTranslation } from 'react-i18next';

export const useTranslation = () => {
    const { t, ...restUseTranslation } = i18nextUseTranslation();
    return {
        t: (key, params) => t(key, params),
        ...restUseTranslation,
    };
};
